import merge from 'lodash/merge';
import moment from 'moment';
import {
  FIELDS,
  DATE_PORTION,
  SORTING,
} from './constants';

moment.locale('pt-br');

export const parseResponse = (response) => {
  return response.data;
};

export const parseParams = (params = {}) => {
  return {
    points_parser: 'series',
    ...params,
  };
};

export const parseTemplate = (entity, template) => {
  if (!typeof template.grouping === 'object' || !template.grouping.length) {
    throw new Error('Grouping is required');
  }

  const allowed_fields = Object.values(FIELDS[entity]);
  template.grouping.forEach((field) => {
    if (!allowed_fields.includes(field)) {
      throw new Error(`Grouping is invalid, check the allowed fields for ${entity}`);
    }
  });

  if (!Object.values(DATE_PORTION).includes(template.datePortion)) {
    throw new Error('DatePortion is invalid');
  }

  return merge({
    sorting: SORTING.ASC,
    defaultTimeSeriesValue: 0,
    method: 'aggregation',
  }, template);
};

export const paramsToQueryString = (params) => {
  return Object.keys(params)
    .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`)
    .join('&');
};

export const getUrl = (path, params) => {
  return `/${path}?${paramsToQueryString(parseParams(params))}`;
};

